import { Stack, TextField } from "@mui/material";
import ChoiceOption from "../ChoiceOption";
import { useQuestions } from "src/context/QuestionsProvider";
import { useAnswer } from "src/context/AnswerProvider";
import { useSubmitAnswers } from "src/hooks/useSubmitAnswers";
import { useTranslation } from "react-i18next";
import { ChangeEvent, useCallback } from "react";
import { QuestionOption } from "src/api/types";

const mapSkipNextQuestion: Record<string, boolean> = {
  FORM_SELECTION: true,
};

const options: QuestionOption[] = [
  {
    follow_up: true,
    label: "Yes",
    value: "Yes",
    slug: "k8x3edqi",
    next_question: null,
    conditions: null,
  },
  {
    follow_up: false,
    label: "No",
    value: "No",
    slug: "wNf7FUWP",
    next_question: null,
    conditions: null,
  },
];

const CustomSingleChoice = () => {
  const followUp = true;
  const tag = useQuestions((q) => q.tag);
  const { answers, setAnswers, details, setDetails } = useAnswer();
  const { submitAnswer, nextQuestion } = useSubmitAnswers();
  const page = "questions";
  const { t } = useTranslation();

  const handleSelect = useCallback(
    (option: QuestionOption) => {
      setAnswers([option.value]);

      if (option.value.includes("No") || !followUp) {
        submitAnswer(
          [option.value],
          option.next_question ?? undefined,
          mapSkipNextQuestion[tag || ""],
        );

        if (tag === "FORM_SELECTION") {
          nextQuestion({ form: option.value });
        }
      }
    },
    [followUp, nextQuestion, setAnswers, submitAnswer, tag],
  );

  const handleDetails = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      setDetails(event.target.value);
    },
    [setDetails],
  );

  return (
    <>
      <Stack gap="8px">
        {options.map((option) => (
          <ChoiceOption
            option={option}
            key={option.value}
            onSelect={handleSelect}
          />
        ))}
      </Stack>
      {followUp && answers[0] === "Yes" && (
        <Stack>
          <TextField
            value={details || ""}
            onChange={handleDetails}
            fullWidth
            multiline
            minRows={5}
            placeholder={t(
              `${page}.allergies-placeholder.text`,
              "Please list any allergies",
            )}
            style={{ borderRadius: "8px" }}
          />
        </Stack>
      )}
    </>
  );
};

export default CustomSingleChoice;
